import { isEqual, isEmpty, differenceBy } from 'lodash';
import { CampoNegociacao } from 'px-business-components';

const hasChangeInArquivos = (newArquivos, initialArquivos) => {
  const hasNew = !isEmpty(newArquivos);
  const hasInitial = !isEmpty(initialArquivos);

  // Se ambos estiverem vazios, não há alteração
  if (!hasNew && !hasInitial) return false;

  // Se apenas um dos dois estiver vazio, há alteração
  if (hasNew !== hasInitial) return true;

  // Verifica se algum dos ids novos não é incluido aos arquivos iniciais
  const diff = differenceBy(newArquivos, initialArquivos, 'id');
  return !isEmpty(diff);
};

export const getCamposNegociacaoProduto = (produto, initialProdutos) => {
  const initialProduto = initialProdutos.find(initProduto => produto.id === initProduto.id);
  const campos = [];

  if (!isEqual(produto.$$precoUnitario, initialProduto.precoUnitario)) {
    campos.push(CampoNegociacao.keys.PRECO_UNITARIO.key);
  }
  if (!isEqual(produto.$$icms, initialProduto.impostos.icms)) {
    campos.push(CampoNegociacao.keys.ICMS.key);
  }
  if (!isEqual(produto.$$ipi, initialProduto.impostos.ipi)) {
    campos.push(CampoNegociacao.keys.IPI.key);
  }
  if (!isEqual(produto.$$especificacaoProduto, initialProduto.especificacaoProduto)) {
    campos.push(CampoNegociacao.keys.ESPECIFICACAO.key);
  }
  if (hasChangeInArquivos(produto.$$arquivosProduto, initialProduto.cotacaoProduto.arquivos)) {
    campos.push(CampoNegociacao.keys.ARQUIVOS_PRODUTO.key);
  }
  return campos;
};

export default {
  getCamposNegociacaoProduto,
};
